import { AppState } from '../rootReducer';
import { createSelector } from 'reselect';
import { UserState } from './user-profile.payload';

const getUserStoreState = (state: AppState): UserState => state.userState;

export const selectUserProfileBasicInfo = (state: AppState) =>
  state.userState.userProfile;


export const selectUserProfile = createSelector(
  getUserStoreState,
  state => state.userProfile
);

export const selectUserLoadingState = createSelector(
  getUserStoreState,
  state => state.isLoading
);

export const guidePlannedRoutes = createSelector(
  getUserStoreState,
  state => state.plannedRoutes
);

export const getUploadingCoverImageLoadingStateSelector = createSelector(
  getUserStoreState,
  state => state.isUploadingCoverImage
);

export const getUploadingProfileImageLoadingStateSelector = createSelector(
  getUserStoreState,
  state => state.isUploadingProfileImage
);

export const getPlannedRoutesLoadingStateSelector = createSelector(
  getUserStoreState,
  state => state.isLoadingPlannedRoutes
);

export const getActivePlannedRouteSelector = createSelector(
  getUserStoreState,
  state => {
    if (state.editingPlannedRoute != null) {
      return state.editingPlannedRoute;
    }
    if (state.plannedRoutes && state.plannedRoutes.length > 0) {
      return state.plannedRoutes.find(route => route.isEnabled) || null;
    }
    return null;
  }
);

export const getPlannedRoutesSavingStateSelector = createSelector(
  getUserStoreState,
  state => state.isSavingPlannedRoutes
);

